"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoModelCommon = exports.setDskFromLocation = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelCommon_1 = require("../../model/ModelCommon");
const selectedConfig_1 = require("../../selectedConfig");
const conversion_1 = require("../../util/geo/S2/conversion");
const number_1 = require("../../util/number");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeName = 'GeoModelCommon';
const setDskFromLocation = function () {
    if (this.location && (0, iotv_v3_types_1.isPosition)(this.location)) {
        this.dsk = (0, conversion_1.convertLatLngLocationToId)(this.location, this.cellLevel);
    }
};
exports.setDskFromLocation = setDskFromLocation;
class GeoModelCommon extends ModelCommon_1.ModelCommon {
    constructor({ ...ob }) {
        super(ob.type ?? typeName, { ...ob });
        this.dpk = this.type; // Developers, especially ADH - do not remove this. It is not unused
        if ((0, iotv_v3_types_1.isNonNaNNumber)(ob.cellLevel)) {
            this.cellLevel = ob.cellLevel;
        }
        if ((0, iotv_v3_types_1.isPosition)(ob.location)) {
            const cellLevel = (0, iotv_v3_types_1.isNonNaNNumber)(ob.cellLevel) ? ob.cellLevel : config_1.default.app.geo.S2.defaultLevel + 2;
            this.dsk = (0, conversion_1.convertLatLngLocationToId)(ob.location, cellLevel);
        }
    }
    /** sets the location and the s2 dsk of this instance */
    setLocation(pos) {
        if ((0, iotv_v3_types_1.isPosition)(pos)) {
            const cellLevel = (0, iotv_v3_types_1.isNonNaNNumber)(this.cellLevel) ? this.cellLevel : config_1.default.app.geo.S2.defaultLevel + 2;
            this.location = pos;
            this.dsk = (0, conversion_1.convertLatLngLocationToId)(this.location, cellLevel);
        }
    }
    get location_lat() {
        return this.location?.lat;
    }
    set location_lat(val) {
        if ((0, number_1.isNumber)(val)) {
            if (!this.location)
                Object.assign(this, { location: {} });
            if (val && this.location)
                this.location.lat = val;
            exports.setDskFromLocation.apply(this);
        }
    }
    get location_lng() {
        return this.location?.lng;
    }
    set location_lng(val) {
        if ((0, number_1.isNumber)(val)) {
            if (!this.location)
                Object.assign(this, { location: {} });
            if (val && this.location)
                this.location.lng = val;
            exports.setDskFromLocation.apply(this);
        }
    }
    get elevation() {
        return this.location?.elevation;
    }
    set elevation(val) {
        if ((0, number_1.isNumber)(val)) {
            if (!this.location)
                Object.assign(this, { location: {} });
            if (this.location)
                this.location.elevation = val;
        }
    }
    set s2CellLevel(level) {
        if ((0, iotv_v3_types_1.isNonNaNNumber)(level)) {
            this.cellLevel = Math.round(level);
            if (this.location) {
                this.dsk = (0, conversion_1.convertLatLngLocationToId)(this.location, this.cellLevel);
            }
        }
    }
    get s2CellLevel() {
        return this.cellLevel;
    }
    getUserAttributes() {
        const { type, ...others } = super.getUserAttributes();
        return {
            // type: {
            //   type: 'String',
            //   editable: false,
            // },
            name: {
                type: 'String',
                editable: true,
            },
            location_lat: {
                type: 'Number',
                precision: 5,
                label: 'Latitude',
                editable: true,
                limits: {
                    min: -90,
                    max: 90,
                },
                hideFromList: true,
            },
            location_lng: {
                type: 'Number',
                precision: 5,
                label: 'Longitude',
                editable: true,
                limits: {
                    min: -180,
                    max: 180,
                },
                hideFromList: true,
            },
            // locationSysUpdateable: {
            //   type: 'Boolean',
            //   label: 'Allow updates',
            // },
            tz: {
                label: 'Timezone',
                type: 'Enum',
                editable: true,
                enumKv: Object.fromEntries(selectedConfig_1.supportedTZs.map((tz) => [tz, tz])),
                hideFromList: true,
            },
        };
    }
    getLatLon() {
        return this.location_lat && this.location_lng ? { lat: this.location_lat, lng: this.location_lng } : undefined;
    }
}
exports.GeoModelCommon = GeoModelCommon;
